import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'components/core/Table';
import { PSPModuleWrapper } from 'components/psp/PSPModuleWrapper';

import './PSPTable.scss';

export default function PSPTable({ tables }) {
	return (
		<PSPModuleWrapper className="psp-table-container">
			{tables.map((rows) => (<Table rows={rows} key={rows} />))}
		</PSPModuleWrapper>
	);
}

PSPTable.propTypes = {
	tables: PropTypes.arrayOf(
		PropTypes.oneOfType([
			PropTypes.array
		])
	).isRequired
};
